import React from "react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

export default function Layout({ children }) {
  return (
    <div className="App bg-[#F4F4EB] min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
